import BaseRepository from "@/baseRepository/BaseRepository";
const resource = `/api/v1/items`;

export default {
  getItemsFilter(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/filter`, {
      baseURL,
      headers,
      params
    });
  },
};